import { StyleSheet } from 'react-native';
import { spacing } from '../../constants/spacing';

export const viewStyles = StyleSheet.create({
  container: {
    flex: 1,
  },
  monthContainer: {
    marginBottom: spacing.small,
  },
});
